import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Logger } from 'src/app/services/datadog.logger.service';
import { FirebaseService } from "../../services/firebase.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.less", "../../../assets/style.less"],
})
export class AdminComponent implements OnInit {
  artistId: string;

  companyName: string;

  constructor(
    private route: Router,
    private logger: Logger,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {
    this.artistId = this.activatedRoute.snapshot.paramMap.get("artistId");

    this.firebaseService.getArtist(this.artistId).subscribe((artist) => {
      this.companyName = artist.get("businessName");
    });
  }

  ngOnInit() {}
}
